var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-widget-v2__row-column-list"},[_c('div',{staticClass:"flex overflow-x-auto gap-x-[14px] scroll-list"},_vm._l((_vm.list),function(item,index){return _c('row-column-item',{key:index,attrs:{"site":_vm.site,"editing":_vm.editing,"good":item,"model":_vm.model},on:{"click":_vm.handleShowDetail,"submit":_vm.onSubmit}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }